/* 曹操傳・第 8 章：烏巢夜襲（建安五年，200）
 * 史實：《三國志·武帝紀》許攸來投，說袁紹的糧車屯在烏巢。曹操「留曹洪守，自將步騎五千人夜往，會明至」。
 *       淳于瓊見曹軍兵少，出營列陣，被曹操急擊退回營中。袁紹派騎兵來救，左右說「賊騎稍近，請分兵拒之」，
 *       曹操怒曰：「賊在背後，乃白！」士卒皆殊死戰，大破瓊等，斬之。《武帝紀》注引《曹瞞傳》說曹軍「用袁軍旗號」夜行。
 * 流程：1. 夜行：打著袁軍旗號沿小路走；路上三處哨卡，走在路上、不出手就不會起疑；離開小路或動手，哨卡就識破、派人去烏巢報信（淳于瓊多了援兵）。
 *       2. 烏巢：燒掉三座糧倉、斬淳于瓊；袁紹的援騎會從背後趕來。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, boss, PEOPLE, TROOPS, rout } from '../kit.ts';
import { POSTS, WUCHAO, GRANS, RELIEF } from '../maps/wuchao.ts';

const LV = 12, START = [1100, 2300], ROAD = [[800, 2300], [1800, 2350], POSTS[0], [3500, 2200], POSTS[1], [5100, 2200], POSTS[2], [6600, 2250], [WUCHAO.x, WUCHAO.y]];
const YUAN = { spec: TROOPS.yuan, name: '袁軍', hp: 460, maxHp: 460, atk: 26 };
const offRoad = (x, y) => { let d = 1e9; for (let i = 0; i < ROAD.length - 1; i++) d = Math.min(d, SG.segDist(x, y, [ROAD[i][0], ROAD[i][1], ROAD[i + 1][0], ROAD[i + 1][1]])); return d > 160; };

export default {
  id: 'caocao-8', map: 'wuchao', hero: 'caocao',
  title: '第 8 章　烏巢夜襲', year: '建安五年（200）',
  brief: {
    quote: [{ text: '留曹洪守，自將步騎五千人夜往，會明至。', src: '《三國志·魏書·武帝紀》' }],
    text: '官渡相持日久，曹軍糧盡。袁紹的謀士許攸來投，說袁軍萬餘輛糧車屯在烏巢，守將淳于瓊防備鬆懈。曹操親率步騎，打著袁軍的旗號連夜出發。',
    goals: ['打著袁軍旗號，沿小路混過哨卡', '燒掉烏巢的三座糧倉', '斬淳于瓊'],
  },
  words: { ally: '曹軍', foe: '袁軍' },
  fuel(m, x, y) { return SG.gd(x, y, WUCHAO.x, WUCHAO.y) < 700 && SG.MAP.walkable(x, y, 0); },
  spreadMul() { return 0.6; },
  stars: [
    { text: '一路沒被哨卡識破', ok: (m) => !m.vars.alarm },
    { text: '三座糧倉全部燒掉', ok: (m) => m.vars.burnt >= 3 },
    { text: '賊在背後，乃白：援騎趕到前斬淳于瓊', ok: (m) => m.vars.killT != null && m.vars.killT < m.vars.reliefT },
  ],
  steps: [
    { // 1. 夜行
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.men = Array.from({ length: 10 }, (_, i) => { const u = m.recruit(me.x - 80 - (i % 5) * 45, me.y - 50 + Math.floor(i / 5) * 90, '曹軍'); u.spec = TROOPS.yuan; u.name = '曹軍（袁軍旗號）'; m.join(u, me); return u; });
        V.posts = POSTS.map(([x, y], k) => ({ x, y, g: [-1, 1].map((s) => { const u = m.foe('huangjin', x + 40, y + s * 130, YUAN); u.asleep = true; u.sus = 0; u.home = [u.x, u.y]; return u; }) }));
        m.line('旁白', '曹軍打著袁軍的旗幟，銜枚縛馬口，從小路連夜出發（據《曹瞞傳》）。');
        m.line('曹操', '打起袁軍的旗號，沿小路走。有人問，就說袁公怕曹操抄後路，派兵來增援。');
        m.after(5, () => m.line('提示', '走在小路上、不出手，哨卡就不會起疑；離開小路或動手就會被識破。'));
        m.obj('go', '沿小路混過三處哨卡，天亮前到烏巢');
        m.mark('wc', WUCHAO.x, WUCHAO.y, '烏巢');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        const hostile = me.act || V.men.some((u) => u.alive && u.target && u.target.alive && u.target.team === 1);
        for (const P of V.posts) for (const u of P.g) {
          if (!u.alive || !u.asleep) continue;
          const d = SG.gd(u.x, u.y, me.x, me.y);
          u.sus = Math.max(0, u.sus - dt * 5);
          if (d < 500 && offRoad(me.x, me.y)) u.sus += dt * 60;
          if ((hostile && d < 600) || u.hp < u.maxHp) u.sus = 100;
          u.target = null; u.think = 0.5;
          if (u.sus >= 100 && !V.alarm) {
            V.alarm = true;
            for (const p of V.posts) for (const o of p.g) o.asleep = false;
            m.line('袁軍', '是曹軍！快去烏巢報信！');
            m.after(1, () => m.line('提示', '被識破了：淳于瓊那邊會多一批守兵。'));
          }
        }
        return m.near(me, WUCHAO.x - 500, WUCHAO.y, 300);
      },
    },
    { // 2. 會明至：燒糧、斬淳于瓊
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('go'); m.unmark('wc');
        V.t2 = w.t; V.reliefT = 75; V.burnt = 0;
        m.card('會明至。', '《武帝紀》');
        V.qiong = boss(w, PEOPLE.yanliang, WUCHAO.x + 300, WUCHAO.y, { name: '淳于瓊', hp: 3600, atk: 44, armor: 8 });
        V.guard = m.camp(WUCHAO.x + 100, WUCHAO.y, [['huangjin', V.alarm ? 12 : 6]], 360).map((u) => Object.assign(u, { spec: TROOPS.yuan, name: '袁軍' }));
        V.grans = GRANS.map(([x, y], k) => { m.mark('g' + k, x, y, '糧倉', true); return { x, y, lit: false, f: m.folk(x, y - 30, { name: '糧倉', still: true, near: 1, draw: SG.campaignDraw.granary }) }; });
        m.line('曹操', '燒糧！斬淳于瓊！');
        m.obj('burn', '燒掉烏巢的糧倉', 3);
        m.obj('qiong', '斬淳于瓊');
        m.mark('q', V.qiong.x, V.qiong.y, '淳于瓊', false, V.qiong);
        // 袁紹的援騎從北邊來
        m.after(V.reliefT, () => {
          if (m.over) return;
          m.line('左右', '賊騎稍近，請分兵拒之！');
          m.after(2, () => m.line('曹操', '賊在背後，乃白！'));
          V.relief = Array.from({ length: 10 }, (_, i) => { const u = m.foe('huangjin', RELIEF[0] - 200 + (i % 5) * 90, RELIEF[1] + Math.floor(i / 5) * 100, Object.assign({}, YUAN, { name: '袁騎', ms: 270 })); u.home = [WUCHAO.x, WUCHAO.y]; return u; });
        });
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        V.grans.forEach((g, k) => {
          if (g.lit) return;
          m.chanAt(me, 'g' + k, g.x, g.y + 60, 180, 2, '燒糧', () => {
            g.lit = true; V.burnt++; m.unmark('g' + k);
            for (const [dx, dy] of [[0, 0], [-80, 40], [80, 40]]) m.fire(g.x + dx, g.y + dy, { dps: 50, life: 20 });
          }, { hurt: false });
        });
        m.prog('burn', V.burnt);
        if (!V.qiong.alive && V.killT == null) { V.killT = w.t - V.t2; m.done('qiong'); m.unmark('q'); m.big('斬淳于瓊！'); }
        return V.burnt >= 3 && !V.qiong.alive;
      },
    },
    { // 3. 大破瓊等
      enter(m, w) {
        const V = m.vars;
        m.done('burn');
        m.card('士卒皆殊死戰，大破瓊等，皆斬之。', '《武帝紀》');
        rout(m, w, (V.relief || []).concat(V.guard), RELIEF);
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) { if (!w.player.alive) m.lose('曹操陣亡'); },
};
